export type ShiftingItemData = {};

export type ShiftingPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

export type ShiftingSearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

export type ShiftingSearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: ShiftingSearchMappingItem[];
};

export type ShiftingListResponse = {
  member: ShiftingItemData[];
  totalItems: number;
  view: ShiftingPagination;
  search: ShiftingSearch;
};

export type ShiftingPageState = {
  page: number;
  itemsPerPage?: number;
  pagination?: boolean;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type ShiftingListStateType = {
  pageState: ShiftingPageState;
  setPageState: (state: ShiftingPageState) => void;
  resetPageState: () => void;
};

export const initialShiftingPageState: ShiftingPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};